import { render, staticRenderFns } from "./HRReports.vue?vue&type=template&id=39e814d5&"
import script from "./HRReports.vue?vue&type=script&lang=ts&"
export * from "./HRReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HRReports.vue"
export default component.exports